import styled from 'styled-components';
import { getAlign, getFont, getType, getWeight, getVariant } from '../utils';

export const H = styled.h1`
  ${({ type }) => getType('h', type)}

  ${({ variant, modifier }) => getVariant(variant, modifier)}

  ${({ weight }) => getWeight('h', weight)}

  ${({ font }) => getFont('h', font)}

  ${({ align }) => getAlign(align)}
`;
